export default class EsEnum {
  constructor(val) {
    if (!val) {
      return
    }
    Object.keys(val).forEach(key => {
      const item = val[key]
      this.addAll(key, item)
    })
    return this
  }

  /**
   * 添加枚举
   * @param key
   * @param item
   */
  addAll(key, item) {
    this[key] = item
  }

  /**
   * 获取所有枚举值列表
   * @returns {Array}
   */
  getItemList() {
    const optionList = []
    for (const i in this) {
      const item = this[i]
      const option = {}
      Object.assign(option, item)
      option.key = i
      optionList.push(option)
    }
    optionList.sort((a, b) => {
      const value1 = a['index']
      const value2 = b['index']
      return value1 - value2
    })
    return optionList
  }

  /**
   * 获取需要排除的枚举值后的所有枚举值列表
   * @param val 需要排除的枚举值或枚举值数组
   */
  getItemListExcept(val) {
    let valueArr = []
    if (val) {
      if (Array.isArray(val)) {
        valueArr = val
      } else {
        valueArr.push(val)
      }
    }
    const optionList = []
    for (const i in this) {
      const item = this[i]
      if (!valueArr.includes(item.name)) {
        const option = {}
        Object.assign(option, item)
        option.key = i
        optionList.push(option)
      }
    }
    return optionList
  }

  /**
   * 根据name获取index
   * @param name
   */
  indexOfName(name) {
    if (name) {
      for (const i in this) {
        const e = this[i]
        if (e.name.toString() === name.toString()) {
          return (e.index)
        }
      }
    }
    return null
  }

  /**
   * 根据index获取name
   * @param index
   * @returns {*}
   */
  nameOfIndex(index) {
    if (index === null) {
      return '--'
    }
    for (const i in this) {
      const e = this[i]
      if (e.index !== undefined && e.index !== null && e.index.toString() === index.toString()) {
        return e.name
      }
    }
    return '--'
  }
}
